import { render, staticRenderFns } from "./Model_Flow_Info.vue?vue&type=template&id=5bcbb59b&scoped=true&"
import script from "./Model_Flow_Info.vue?vue&type=script&lang=js&"
export * from "./Model_Flow_Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbb59b",
  null
  
)

export default component.exports